import React from 'react'
import ReactDOM from 'react-dom'
import Cookies from 'js-cookie'
import { userService } from '../../_services/user.service'
import { APP_NAME } from '../../brand'
const AUTH_BASE =
  process.env.NODE_ENV === 'development' ? 'http://localhost:5000' : ''

class FacebookLoginModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      mode: 'social',
      name: '',
      email: '',
      password: '',
      error: '',
      loading: false
    }
    this.handleCloseClick = this.handleCloseClick.bind(this)
    this.handleBackdropClick = this.handleBackdropClick.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  handleCloseClick() {
    this.props.handleModalCloseClick()
  }

  handleBackdropClick(e) {
    if (e.target === e.currentTarget) this.handleCloseClick()
  }

  async handleSubmit(e) {
    e.preventDefault()
    const { mode, name, email, password } = this.state

    if (mode === 'signup' && !name.trim()) {
      return this.setState({ error: 'Your name is required.' })
    }
    if (!email.trim()) return this.setState({ error: 'Email is required.' })
    if (!password) return this.setState({ error: 'Password is required.' })
    if (password.length < 6) return this.setState({ error: 'Password must be at least 6 characters.' })

    this.setState({ loading: true, error: '' })

    try {
      const url = mode === 'signup'
        ? '/endpoint/auth/email/signup'
        : '/endpoint/auth/email/signin'

      const body = mode === 'signup'
        ? { name: name.trim(), email: email.trim(), password }
        : { email: email.trim(), password }

      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      })

      const data = await res.json()

      if (data.status === 'success') {
        if (data.token) {
          Cookies.set('token', data.token, { expires: 7 })
        }
        userService.loadUserInfo()

        this.handleCloseClick()
        if (data.user && data.user.status === 'profile_not_complete') {
          window.location.href = '/complete-profile'
        } else {
          window.location.reload()
        }
      } else if (data.status === 'verify') {
        this.setState({ mode: 'verify-sent', loading: false, error: '' })
      } else if (data.status === 'unverified') {
        this.setState({ mode: 'verify-resend', loading: false, error: '' })
      } else {
        this.setState({ error: data.message || 'Something went wrong.', loading: false })
      }
    } catch (err) {
      console.log(err)
      this.setState({ error: 'Connection error — try again.', loading: false })
    }
  }

  render() {
    const { mode, name, email, password, error, loading } = this.state

    return ReactDOM.createPortal(
      <div className="ng-modal-backdrop" onClick={this.handleBackdropClick}>
        <div className="ng-modal" role="dialog" aria-modal="true" style={{ maxWidth: 420 }}>
          <div className="ng-modal-header">
            <h5 className="ng-modal-title">
              <span className="ng-wordmark-key" style={{ width: 24, height: 24, fontSize: 14, marginRight: 8, verticalAlign: 'middle' }}>⌂</span>
              {mode === 'signup' ? 'Create your account' : 'Sign in to ' + APP_NAME}
            </h5>
            <button type="button" className="ng-modal-close" onClick={this.handleCloseClick}>&times;</button>
          </div>
          <div className="ng-modal-body">

            {/* Social login buttons */}
            {mode === 'social' ? (
              <>
                <div className="ng-login-stack">
                  <a href={`${AUTH_BASE}/endpoint/auth/google`} className="ng-btn ng-btn-lg ng-btn-google">
                    <span className="fab fa-google"></span> Continue with Google
                  </a>
                </div>

                <div className="ng-login-divider">
                  <span>or</span>
                </div>

                <button className="ng-btn ng-btn-ghost ng-btn-block"
                  onClick={() => this.setState({ mode: 'signin', error: '' })}>
                  <span className="fa fa-envelope" style={{ marginRight: 6 }}></span>
                  Sign in with email
                </button>

                <p style={{ textAlign: 'center', margin: '14px 0 0' }}>
                  <button className="ng-link-btn"
                    onClick={() => this.setState({ mode: 'signup', error: '' })}>
                    New here? <strong>Create an account</strong>
                  </button>
                </p>
              </>
            ) : mode === 'forgot' ? (
              /* Forgot password form */
              <form onSubmit={async e => {
                e.preventDefault()
                this.setState({ loading: true, error: '' })
                try {
                  await fetch('/endpoint/auth/email/forgot-password', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ email: email.trim() })
                  })
                  this.setState({ loading: false, error: '', mode: 'forgot-sent' })
                } catch (err) {
                  this.setState({ loading: false, error: 'Something went wrong.' })
                }
              }}>
                <p style={{ color: '#64748b', fontSize: 14, marginBottom: 16 }}>
                  Enter your email and we'll send you a link to reset your password.
                </p>
                <div className="ng-field">
                  <label>Email</label>
                  <input className="ng-input" type="email"
                    placeholder="you@example.com" value={email}
                    onChange={e => this.setState({ email: e.target.value })} />
                </div>
                {error ? <div className="ng-error" style={{ marginBottom: 12 }}>{error}</div> : null}
                <button type="submit" className="ng-btn ng-btn-primary ng-btn-block" disabled={loading}>
                  {loading ? 'Sending…' : 'Send reset link'}
                </button>
                <p style={{ textAlign: 'center', margin: '12px 0 0' }}>
                  <button className="ng-link-btn" onClick={() => this.setState({ mode: 'signin', error: '' })}>
                    ← Back to sign in
                  </button>
                </p>
              </form>
            ) : mode === 'forgot-sent' ? (
              <div style={{ textAlign: 'center', padding: '20px 0' }}>
                <span className="fa fa-check-circle" style={{ fontSize: 48, color: '#10b981', display: 'block', marginBottom: 16 }}></span>
                <p style={{ fontSize: 15, fontWeight: 700, marginBottom: 8 }}>Link sent</p>
                <p style={{ color: '#64748b', fontSize: 14 }}>Check your inbox and follow the link to reset your password.</p>
                <button className="ng-btn ng-btn-ghost ng-btn-sm" style={{ marginTop: 12 }}
                  onClick={() => this.setState({ mode: 'signin', error: '' })}>
                  Back to sign in
                </button>
              </div>
            ) : mode === 'verify-sent' ? (
              <div style={{ textAlign: 'center', padding: '20px 0' }}>
                <span className="fa fa-envelope" style={{ fontSize: 48, color: 'var(--ng-primary)', display: 'block', marginBottom: 16 }}></span>
                <p style={{ fontSize: 17, fontWeight: 800, marginBottom: 8 }}>Confirm your email</p>
                <p style={{ color: '#64748b', fontSize: 14, lineHeight: 1.8 }}>
                  We sent a confirmation email to <strong style={{ color: 'var(--ng-ink)' }}>{email}</strong>
                  <br />Click the link in the email to activate your account.
                </p>
                <p style={{ color: '#94a3b8', fontSize: 12, marginTop: 16 }}>Nothing there? Check your spam folder.</p>
                <button className="ng-btn ng-btn-ghost ng-btn-sm" style={{ marginTop: 8 }}
                  onClick={() => this.setState({ mode: 'signin', error: '' })}>
                  Back to sign in
                </button>
              </div>
            ) : mode === 'verify-resend' ? (
              <div style={{ textAlign: 'center', padding: '20px 0' }}>
                <span className="fa fa-exclamation-circle" style={{ fontSize: 48, color: '#f59e0b', display: 'block', marginBottom: 16 }}></span>
                <p style={{ fontSize: 15, fontWeight: 700, marginBottom: 8 }}>Email not confirmed</p>
                <p style={{ color: '#64748b', fontSize: 14, lineHeight: 1.8 }}>
                  Please confirm your email first — check your inbox.
                </p>
                <button className="ng-btn ng-btn-primary ng-btn-sm" style={{ marginTop: 12 }}
                  disabled={loading}
                  onClick={async () => {
                    this.setState({ loading: true })
                    try {
                      await fetch('/endpoint/auth/email/resend-verification', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ email })
                      })
                    } catch (e) {}
                    this.setState({ loading: false, mode: 'verify-sent' })
                  }}>
                  {loading ? 'Sending…' : 'Resend confirmation email'}
                </button>
                <br />
                <button className="ng-link-btn" style={{ marginTop: 12 }}
                  onClick={() => this.setState({ mode: 'signin', error: '' })}>
                  Back to sign in
                </button>
              </div>
            ) : (
              /* Email signin / signup form */
              <form onSubmit={this.handleSubmit}>
                {mode === 'signup' ? (
                  <div className="ng-field">
                    <label>Name</label>
                    <input className="ng-input" type="text" placeholder="Full name"
                      value={name} onChange={e => this.setState({ name: e.target.value })} />
                  </div>
                ) : null}

                <div className="ng-field">
                  <label>Email</label>
                  <input className="ng-input" type="email"
                    placeholder="you@example.com" value={email}
                    onChange={e => this.setState({ email: e.target.value })} />
                </div>

                <div className="ng-field">
                  <label>Password</label>
                  <input className="ng-input" type="password"
                    placeholder={mode === 'signup' ? 'At least 6 characters' : 'Password'}
                    value={password} onChange={e => this.setState({ password: e.target.value })} />
                </div>

                {error ? <div className="ng-error" style={{ marginBottom: 12 }}>{error}</div> : null}

                <button type="submit" className="ng-btn ng-btn-primary ng-btn-block" disabled={loading}>
                  {loading ? 'Loading…' : mode === 'signup' ? 'Create account' : 'Sign in'}
                </button>

                {mode === 'signin' ? (
                  <p style={{ textAlign: 'center', margin: '10px 0 0' }}>
                    <button className="ng-link-btn" onClick={() => this.setState({ mode: 'forgot', error: '' })}>
                      Forgot your password?
                    </button>
                  </p>
                ) : null}

                <div className="ng-login-divider"><span>or</span></div>

                <button type="button" className="ng-btn ng-btn-ghost ng-btn-block"
                  onClick={() => this.setState({ mode: 'social', error: '' })}>
                  <span className="fab fa-google" style={{ marginRight: 6 }}></span>
                  Continue with Google
                </button>

                <p style={{ textAlign: 'center', margin: '12px 0 0' }}>
                  <button className="ng-link-btn"
                    onClick={() => this.setState({ mode: mode === 'signup' ? 'signin' : 'signup', error: '' })}>
                    {mode === 'signup' ? 'Already have an account? ' : 'New here? '}
                    <strong>{mode === 'signup' ? 'Sign in' : 'Create an account'}</strong>
                  </button>
                </p>
              </form>
            )}

            <p style={{ textAlign: 'center', color: '#94a3b8', fontSize: 11, margin: '14px 0 0' }}>
              By continuing you agree to our{' '}
              <a href="/tos" target="_blank" rel="noopener noreferrer"
                style={{ color: 'var(--ng-primary)', fontWeight: 700, textDecoration: 'underline' }}>
                Terms of Service and Privacy Policy
              </a>
            </p>
          </div>
        </div>
      </div>,
      document.body
    )
  }
}

export default FacebookLoginModal
